import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Bank_Account, Currency } from 'src/app/models/RestModels';
import { BaseComponent } from 'src/app/pages/base/base.component';

@Component({
	selector: 'app-add-withdrawal',
	templateUrl: './add-withdrawal.component.html',
	styleUrls: ['./add-withdrawal.component.css']
})
export class AddWithdrawalComponent extends BaseComponent
{
	total: number | null = null;
	note: string = '';
	imprimir_recibo: boolean = true;
	bank_account_list: Bank_Account[] = [];
	dest_bank_account_id: number | null = null;
	currency_list: Currency[] = [];
	currency_id: string = 'MXN';
	@Input() store_id: number | null = null;
	@Output() withdrawalAdded = new EventEmitter<void>();

	ngOnInit(): void
	{
		this.total = null;
		this.note = '';
		this.dest_bank_account_id = null;

		this.subs.sink = this.rest.bank_account.search({})
			.subscribe((response) =>
			{
				this.bank_account_list = response.data;
			}, (error) => this.showError(error));

		this.subs.sink = this.rest.currency.search({ limit: 999999 })
			.subscribe((response) =>
			{
				this.currency_list = response.data;
			}, (error) => this.showError(error));
	}

	save(evt: Event)
	{
		evt.preventDefault();
		this.is_loading = true;

		let now = new Date();
		let pad = (n: number) => (n < 10 ? '0' : '') + n;
		let mysql_datetime = now.getFullYear() + '-' +
			pad(now.getMonth() + 1) + '-' +
			pad(now.getDate()) + ' ' +
			pad(now.getHours()) + ':' +
			pad(now.getMinutes()) + ':' +
			pad(now.getSeconds());

		let payload: any = {
			amount: this.total,
			currency_id: this.currency_id,
			currency: this.currency_id,
			device_time: mysql_datetime,
			store_id: this.store_id,
			note: this.note,
		};

		if (this.dest_bank_account_id)
		{
			payload.dest_bank_account_id = this.dest_bank_account_id;
		}

		this.subs.sink = this.rest.withdrawal_info
			.create(payload)
			.subscribe((response: any) =>
			{
				let withdrawal = response?.withdrawal || response;
				if (this.imprimir_recibo && withdrawal?.id)
				{
					window.open('/#/print-withdrawal/' + withdrawal.id + '/print=1');
				}
				this.showSuccess('El retiro se guardó exitosamente');
				this.resetForm();
				this.withdrawalAdded.emit();
				this.is_loading = false;
			}, (error) => this.showError(error));
	}

	resetForm()
	{
		this.total = null;
		this.note = '';
		this.dest_bank_account_id = null;
		this.currency_id = 'MXN';
	}

	cancel()
	{
		this.withdrawalAdded.emit();
	}

	imprimirChanged(evt: Event)
	{
		let input = evt.target as HTMLInputElement;
		this.imprimir_recibo = input.checked;
	}
}
